import { DividerProps, Divider as MuiDivider } from "@mui/material"
import classNames from "classnames"

import "./divider.scss"

export default function Divider(props: DividerProps) {
  return <MuiDivider {...props} className={classNames("DividerCont", props.className)} flexItem />
}
